import scrollTo from './scrollTo'

const body = document.getElementsByTagName('body')[0]
let locked = false
let prevScroll = {}
let prevStyles = ''

// Used to determine if can be unlocked.
// If it's true, scroll can't be unlocked unless unlock method receives forceUnlock param with true value
let forceBlocked = false

const lockStyles = 'position: fixed; height: 100%; width: 100%;'

const cacheStyles = function () {
  prevStyles = body.getAttribute('style') || ''
  prevScroll = {
    scrollLeft: window.scrollX,
    scrollTop: window.scrollY,
  }
}

const isLock = () => locked

const lock = (forceBlock = false) => {
  if (!locked) {
    locked = true
    cacheStyles()
    let bodyStyles = lockStyles
    bodyStyles += `height: auto; top: -${prevScroll.scrollTop}px; left: -${prevScroll.scrollLeft}px;`
    body.setAttribute('style', bodyStyles)
    body.classList.add('scroll-lock-on')
  }

  if (forceBlock) {
    forceBlocked = true
  }
}

const unlock = (forceUnlock = false) => {
  if (locked && (!forceBlocked || forceUnlock)) {
    locked = false
    forceBlocked = false
    body.setAttribute('style', prevStyles)
    body.classList.remove('scroll-lock-on')
    scrollTo({ xCoord: prevScroll.scrollLeft, yCoord: prevScroll.scrollTop })
  }
}

const calcOverflow = () => {
  const hh = body.clientHeight()
  const hw = body.clientWidth()
  const wh = window.innerHeight()
  const ww = window.innerWidth()

  if (wh >= hh && ww >= hw) {
    lockStyles['overflow'] = 'hidden'
  } else {
    lockStyles['overflow-x'] = ww >= hw ? 'hidden' : 'scroll'
    lockStyles['overflow-y'] = wh >= hh ? 'hidden' : 'scroll'
  }
}

window.ScrollLock = {
  on: lock,
  off: unlock,
  isLock,
  toggle() {
    locked ? unlock() : lock()
  },
  update: calcOverflow,
}
